import React, { useState, useEffect } from 'react';
import Spinner from '../../../Spinner';
import checkIcon from '../../../../assets/icons/check-icon.png';
import axios from 'axios';
import { useUserContext } from '../../../../contexts/UserContext';

export default function AreaAlertsModal(props) {
    const {
        alert,
        setAlerts,
        alerts,
        setAlert,
        setModal,
        modal
    } = props;

    const {
        getToken
    } = useUserContext();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const areaId = modal.content?.areaId;

    useEffect(() => {
        if (alerts.filter((a) => a && a.area_id === areaId).length > 0) {
            setAlert(alerts.filter((a) => a && a.area_id === areaId)[0]);
        }
    }, [alerts]);

    const turnOnNotifications = (areaId) => {
        setLoading(true);
        getToken()
        .then((token) => {
            axios.post('https://firewatch-api.space-eyes.com/user/notifications', 
            {
                team_id: null,
                area_id: areaId,
                incident_id: null
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                console.log('API Response:', response.data);
                console.log('Current alerts before update:', alerts);
                setAlerts([
                    ...alerts.filter((a) => a && a.id !== response.data.id),
                    response.data
                ])
                setLoading(false);
            }).catch((error) => {
                console.log('error turning on notifications', error);
                setLoading(false);
                setError('Trouble turning on notifications. Please try again.');
            })
        })
        .catch((error) => {
            console.error('Failed to get token:', error);
            setError('Trouble turning on notifications. Please try again')
        });
    }
 
    const turnOffNotifications = (alertID) => {
        setLoading(true);
        getToken()
        .then((token) => {
            axios.delete(`https://firewatch-api.space-eyes.com/user/notifications?id=${alertID}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
            setAlerts(alerts.filter((a) => a.id !== alertID));
            setAlert(null);
            setLoading(false);
            }).catch((error) => {
                console.log('error turning off notifications', error);
                setLoading(false);
                setError('Trouble turning off notifications. Please try again.')
            })
        })
        .catch((error) => {
            console.error('Failed to get token:', error);
            setError('Trouble turning off notifications. Please try again.')
        });
    }

    return (
        <div className='areas-modal'>
            <div className='areas-modal-title'>Monitoring Area Alerts</div>
            <div className='areas-modal-content'>
                <div className='areas-modal-content-text'>Receive real-time email alerts when a new fire or fire prediction is detected in your Monitoring Area.</div>
                <div className='areas-modal-content-alert'>
                    <div className='areas-modal-content-alert-top'>
                        <div className='areas-modal-content-alert-top-text'>Email</div>
                        <img src={checkIcon} className='areas-modal-content-alert-top-icon'/>
                    </div>
                    <div className='areas-modal-content-alert-bottom'>cesar@space-eyes.com</div>
                </div>
            </div>
            {error && <div className='areas-modal-content-error'>{error}</div>}
            {loading ?
            <div style={{ paddingTop: '1rem' }}>
                <Spinner />
            </div>
            :
            <div className='areas-modal-content-alert-btns'>
                {!alert ?
                <div 
                    className='areas-modal-content-alert-btns-btn-save'
                    onClick={() => turnOnNotifications(areaId)}
                    >
                 Turn On
                </div>
                :
                <div 
                    className='areas-modal-content-alert-btns-btn-off'
                    onClick={() => turnOffNotifications(alert.id)}
                    >
                 Turn Off
                </div>
                }
                <div 
                    className='areas-modal-content-alert-btns-btn-cancel'
                    onClick={() => {
                        setModal({
                            type: false,
                            content: null
                        })
                    }}
                    >
                    Cancel
                </div>
            </div>
            }
        </div>
    )
}
